<div class="container text-center page-not-found">
  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
  <p class="number404 my-5">404</p>
  <h1 class="display-4">Page Not Found</h1>
  <p class="lead">The page you are looking for does not exist.</p>
  <button (click)="goBackHome()" class="mt-3" mat-raised-button color="primary">Go Back Home</button>
</div>